<template>
    <v-container v-if="loadSkeleton">
        <SkeletonLoader tipo="table" ruta="turnos" />
    </v-container>
    <v-container v-else class="d-flex flex-column">
        <DialogoDetallePago ref="dialDetalle" titulo="Detalle de pago" :selectedItem="this.selectedItem" />
        <DialogoComprobantePago ref="dialComprobante" titulo="Comprobante de pago" :selectedItem="this.selectedItem" />
        <v-card-title class="text-h5 font-weight-bold">
            <v-icon color="primary" class="mr-3" size="34">mdi-cash-multiple</v-icon>
            Mis pagos
            <v-spacer></v-spacer>
            <v-btn class="pa-5 elevation-0" :loading="loading" @click="refrescarItems" color="primary">
                <v-icon class="mr-2">mdi-refresh</v-icon>actualizar
            </v-btn>
        </v-card-title>
        <v-card outlined class="rounded-0 ma-2 pa-2">
            <v-card-title>
                <div class="font-weight-bold primary--text text-h6">
                    Pagos realizados
                </div>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                    hide-details></v-text-field>
            </v-card-title>

            <!-- Footer personalizado arriba de la tabla -->
            <v-card-text class="d-flex align-center px-4 py-2"
                style="border-top: 1px solid #E0E0E0; border-bottom: 1px solid #E0E0E0;"
                :class="$vuetify.breakpoint.mdAndUp ? ' justify-end' : 'flex-column'">
                <div class="d-flex align-end" :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : 'mr-5'">
                    <span class="font-weight-bold text-body-2 mr-2">Filas por página:</span>
                    <v-text-field v-model.number="itemsPerPage" type="number" dense hide-details
                        style="max-width: 80px;" :min="5" :max="50"></v-text-field>
                </div>

                <div class="d-flex align-center justify-center">
                    <span class="text-body-2 mr-3">
                        {{ getPageRangeText() }}
                    </span>
                    <v-btn class="mx-1" fab x-small color="primary" :disabled="page === 1" @click="page = 1"
                        style="z-index: 3;">
                        <v-icon color="white" small>mdi-page-first</v-icon>
                    </v-btn>
                    <v-btn class="mx-1" fab x-small color="primary" :disabled="page === 1" @click="page--"
                        style="z-index: 3;">
                        <v-icon color="white" small>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn class="mx-1" fab x-small color="primary" :disabled="page >= totalPages" @click="page++"
                        style="z-index: 3">
                        <v-icon color="white" small>mdi-chevron-right</v-icon>
                    </v-btn>
                    <v-btn class="mx-1" fab x-small color="primary" :disabled="page >= totalPages"
                        @click="page = totalPages" style="z-index: 3">
                        <v-icon color="white" small>mdi-page-last</v-icon>
                    </v-btn>
                </div>
            </v-card-text>

            <v-data-table :headers="headerPagos" :items="paginatedItems" :loading="loading" :search="search"
                hide-default-footer disable-pagination>
                <template v-slot:item.detalle="{ item }">
                    <div class="font-weight-bold text-body-1"
                        style="word-wrap: break-word; text-wrap: balance; text-overflow: ellipsis;">
                        {{item.detalle.map(d => d.descripcion).join(', ')}}
                    </div>
                </template>
                <template v-slot:item.mmp_fecpago_real="{ item }">
                    <div class="font-weight-regular text-body-2">
                        {{ item.mmp_fecpago_real }}
                    </div>
                </template>
                <template v-slot:item.mmp_apagar="{ item }">
                    <v-chip color="primary" label class="font-weight-bold white--text"> {{ formatMoney(item.mmp_apagar)
                    }}</v-chip>
                </template>
                <template v-slot:item.ver_detalle="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn fab text color="primary" @click="desplegarDetalleDialogo(item)" class="ma-1"
                                v-bind="attrs" v-on="on">
                                <v-icon>mdi-list-box-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Ver detalle</span>
                    </v-tooltip>
                </template>
                <template v-slot:item.descarga="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn fab text color="primary" @click="desplegarComprobanteDialogo(item)" class="ma-1"
                                v-bind="attrs" v-on="on">
                                <v-icon>mdi-download-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Ver comprobante</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue';
import { mapActions, mapGetters } from 'vuex';
import DialogoDetallePago from '@/components/dialogos/DialogoDetallePago.vue';
import DialogoComprobantePago from '../components/dialogos/DialogoComprobantePago.vue';

export default {

    components: {
        SkeletonLoader,
        DialogoDetallePago,
        DialogoComprobantePago,
    },

    data() {
        return {
            selectedItem: '',
            loading: false,
            search: '',
            itemsPerPage: 10,
            page: 1,

            headerPagos: [
                { text: 'CONCEPTO', value: 'detalle', sortable: false, align: 'center', class: 'primary--text  font-weight-bold', width: '30%' },
                { text: 'FECHA DE PAGO', value: 'mmp_fecpago_real', sortable: false, align: 'center', class: 'primary--text  font-weight-bold' },
                { text: 'IMPORTE', value: 'mmp_apagar', align: 'center', sortable: false, class: 'primary--text  font-weight-bold' },
                /*   { text: 'DESCRIPCION', value: 'detalle_resumen', align: 'center', sortable: false, class: 'primary--text text--darken-1' }, */
                { text: 'DETALLE', value: 'ver_detalle', align: 'center', sortable: false, class: 'primary--text  font-weight-bold' },
                { text: 'DESCARGAR', value: 'descarga', align: 'center', sortable: false, class: 'primary--text  font-weight-bold' }
            ],
        }
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'loadSkeleton', 'nroafi', 'user']),
        ...mapGetters('boletas', ['pagosRealizados']),
        pagosRealizadosOrdenados() {
            // Ordena descendente por fecha y hora (más reciente primero)
            function parseFecha(fechaStr) {
                // Espera formato 'DD/MM/YYYY HH:mm'
                const [fecha, hora] = fechaStr.split(' ');
                const [dia, mes, anio] = fecha.split('/');
                const [h, m] = hora ? hora.split(':') : [0, 0];
                return new Date(
                    parseInt(anio),
                    parseInt(mes) - 1,
                    parseInt(dia),
                    parseInt(h),
                    parseInt(m)
                );
            }
            return [...this.pagosRealizados].sort((a, b) => {
                return parseFecha(b.mmp_fecpago_real) - parseFecha(a.mmp_fecpago_real);
            });
        },
        filteredItems() {
            if (!this.search) return this.pagosRealizadosOrdenados;

            const searchLower = this.search.toLowerCase();
            return this.pagosRealizadosOrdenados.filter(item => {
                const detalle = item.detalle.map(d => d.descripcion).join(', ').toLowerCase();
                const fecha = item.mmp_fecpago_real.toLowerCase();
                const importe = item.mmp_apagar.toString();

                return detalle.includes(searchLower) ||
                    fecha.includes(searchLower) ||
                    importe.includes(searchLower);
            });
        },
        totalPages() {
            return Math.ceil(this.filteredItems.length / this.itemsPerPage);
        },
        paginatedItems() {
            const start = (this.page - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredItems.slice(start, end);
        },
    },
    watch: {
        itemsPerPage() {
            this.page = 1; // Reset a la primera página cuando cambia el número de items
        },
        search() {
            this.page = 1; // Reset a la primera página cuando se busca
        },
    },
    methods: {
        formatMoney(value) {
            return value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
        },
        getPageRangeText() {
            const start = (this.page - 1) * this.itemsPerPage + 1;
            const end = Math.min(this.page * this.itemsPerPage, this.filteredItems.length);
            return `${start}-${end} de ${this.filteredItems.length}`;
        },
        desplegarDetalleDialogo(item) {
            this.selectedItem = item;
            this.$refs.dialDetalle.abrirDialogo();
        },
        desplegarComprobanteDialogo(item) {
            this.selectedItem = item;
            this.$refs.dialComprobante.abrirDialogo();
        },
        refrescarItems() {
            this.loading = true;
            this.$store.dispatch('boletas/getConsultarPagos').finally(() => {
                this.loading = false;
            });
        },
    },
}
</script>

<style scoped>
@media (max-width: 600px) {
    .v-data-table__sort {
        display: none !important;
    }
}
</style>
